import { AdaptorTypes, ConfigLayer } from '@Map/types';
import { Info360TileMetadataV2 } from '@Map/services/Info360TileTypes';
import ExternalConfigAdaptor from './ExternalConfigAdaptor';
import { TileJson } from '@Map/services/types';

/**
 * SensorConfigAdaptor - Extracts Sensor system from V3 response and creates layer config
 */
export default class SensorConfigAdaptor extends ExternalConfigAdaptor {
	static _type: AdaptorTypes = AdaptorTypes.sensor;
	static _endpointPathname = '/v3/tileset-index';

	/**
	 * Convert sensor data from V3 tileset to layer configuration
	 * @param data Info360TileMetadataV2 response (full V3 response)
	 * @returns partial configuration object for sensor layers
	 */
	converter = (data: Info360TileMetadataV2): Partial<ConfigLayer> => {
		// Extract Sensors from the systems
		const sensorData = data.systems?.['Sensors'];

		if (!sensorData || Array.isArray(sensorData)) {
			return {};
		}

		const tileJson = sensorData as TileJson;

		// Create layers from vector_layers
		const layers: ConfigLayer['layers'] = tileJson.vector_layers.map(
			layer => ({
				layerName: layer.description || layer.id,
				id: layer.id,
				tileSource: 'Sensors',
				tileLayerName: layer.id,
				type: this._getLayerType(layer.geometry),
				minZoom: layer.minzoom,
			}),
		);

		return { layers };
	};

	/**
	 * Map geometry type to layer type
	 */
	private _getLayerType(
		geometry: string,
	): 'symbol' | 'line' | 'polygon' | 'fill' {
		const lowerGeometry = geometry.toLowerCase();
		if (lowerGeometry.includes('point')) {
			return 'symbol';
		} else if (lowerGeometry.includes('line')) {
			return 'line';
		} else if (lowerGeometry.includes('polygon')) {
			return 'fill';
		}
		return 'symbol'; // default
	}
}

export const sensorConfigCreatorV3 =
	SensorConfigAdaptor.creator.bind(SensorConfigAdaptor);
